import type React from 'react';
import { Heart, Text } from '@doda/io-react/common';
import type { JobDetailResponse } from '@doda/api-client/aspida/@types';
import classNames from 'classnames';
import styles from './index.module.scss';

/**
 * MatchingBalloonProps
 */
interface MatchingBalloonProps {
  welcomeMatch: JobDetailResponse['welcomeMatch'];
  wcnsId: string;
  hasInterested: boolean;
}

export const MatchingBalloon = ({
  welcomeMatch,
  wcnsId,
  hasInterested,
}: MatchingBalloonProps) => {
  const type = welcomeMatch?.type || null;
  const message = welcomeMatch?.message || null;
  const imgUrl = welcomeMatch?.image || null;

  const showInterestedByCompany = !type && hasInterested;
  const title = buildTitle(type, wcnsId, hasInterested);

  return (
    <div
      className={classNames('jobSearchDetail-matchingBalloon', {
        [styles['jobSearchDetail-matchingBalloon-browsed']]: type === '2', // 閲覧マッチング
        [styles['jobSearchDetail-matchingBalloon-interested']]: hasInterested, // 企業から気になるマッチング
      })}
    >
      <div className={styles['jobSearchDetail-matchingBalloon__title']}>
        {!showInterestedByCompany && imgUrl && (
          <div className={styles['jobSearchDetail-matchingBalloon__imageArea']}>
            <span
              className={
                styles['jobSearchDetail-matchingBalloon__imageContainer']
              }
            >
              <img
                loading="lazy"
                src={imgUrl}
                alt=""
                className={styles['jobSearchDetail-matchingBalloon__image']}
              />
            </span>
            <span
              className={styles['jobSearchDetail-matchingBalloon__image-dummy']}
            />
          </div>
        )}
        <Heart color={hasInterested ? 'orange' : 'yellow'} size="M" />
        <Text as="span" size="16" weight="bold">
          {title}
        </Text>
      </div>
      {message && (
        <div className={styles['jobSearchDetail-matchingBalloon__messageArea']}>
          <div className={styles['jobSearchDetail-matchingBalloon__message']}>
            <Text as="p" color="black_pc" size="14--articlePC" weight="normal">
              {message}
            </Text>
          </div>
        </div>
      )}
    </div>
  );
};

/**
 * マッチング種類によるタイトルを返す
 */
function buildTitle(
  type: string | null,
  wcnsId: string,
  hasInterested: boolean
): React.ReactNode {
  // 気になるマッチング
  if (type === '1')
    return (
      <>
        マッチング成立！
        <Text as="span" size="12" weight="bold">
          応募をお待ちしています。
        </Text>
      </>
    );
  // 閲覧履歴マッチング
  if (type === '2')
    return wcnsId === 'T'
      ? 'この求人はあなたの経験にマッチしています'
      : 'この企業はあなたの応募を歓迎しています';
  if (hasInterested) return 'マッチングしやすいおすすめ求人';
  return '';
}
